import React, { ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

interface Toolbar {
  children?: ReactNode
  className?: string
}

const Toolbar: React.FC<Toolbar> = ({ children, className = '' }) => {
  return (
    <div
      className={twMerge(
        'flex flex-col items-center justify-between py-1 px-4 w-full border-b border-primary-300 dark:border-primary-800 bg-white dark:bg-primary-900',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default Toolbar
